﻿import { createFileRoute } from "@tanstack/react-router";
import { SistemaPage } from "@/paginas/pg_sistema/sistema-main";

export const Route = createFileRoute("/_authenticated/sistema")({
  head: () => ({
    meta: [
      { title: "Sistema — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Central de configurações do sistema: usuários, auditoria, parâmetros, anexos, notificações e ferramentas de desenvolvimento.",
      },
      { property: "og:title", content: "Sistema — Milky Moo Palmares" },
      {
        property: "og:description",
        content:
          "Central de configurações do sistema: usuários, auditoria, parâmetros, anexos, notificações e ferramentas de desenvolvimento.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: SistemaPage,
});
